<template>
    <div class="box">
        <article class="media">
            <div class="media-left">
                <figure class="image is-64x64">
                    <img src="@/assets/manager.png" alt="Image">
                </figure>
            </div>
            <div class="media-content">
                <div class="content">
                    <p>
                        <strong>{{ name }}</strong>
                        <br>
                        Hello, I'm your personal manager. Please feel free to contact me.
                    </p>
                </div>
                <nav class="level is-mobile">
                    <div class="level-left">
                        <a class="level-item" aria-label="reply">
                            <span class="icon is-small">
                              <i class="fas fa-at"></i>
                            </span>
                             {{ email }}
                        </a>
                    </div>
                </nav>
            </div>
        </article>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                name: this.$store.getters.getCurrentUser.info.manager.name,
                email: this.$store.getters.getCurrentUser.info.manager.email
            }
        },
        mounted () {

        }
    }
</script>

<style scoped>
    .box {
        min-height: 155px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Manager.vue